import React from 'react';
import growResponsive from '../../assets/grow-responsive.png';
import womenSmile from '../../assets/women-smile.png';

import { useDisplay } from '../../hook/useDisplay';
import { Container, ContaineText } from './style';

function Grow() {
  const { isLargeDisplay } = useDisplay();
  return (
    <Container>
      {isLargeDisplay() ? (
        <>
          <ContaineText>
            <p>
              Crescimento <br />
              exponencial <br />
              pro seu negócio
            </p>
          </ContaineText>
          <img src={womenSmile} alt="crescimento" />
        </>
      ) : (
        <img src={growResponsive} alt="crescimento" />
      )}
    </Container>
  );
}

export default Grow;
